import {defaultTheme} from '@stencil/build-theme';
import React from 'react';
import {SectionHeader} from '../../../../CommonStyleUtils/dwebCommon.styles';
import useCarousel from '../../../../../../shared/hooks/useCarousel';
import {ISegmentSliderData} from '@stencil/hotels-common-reducer/src/types';
import LeftArrowIcon from '../../../../../../stories/Icons/LeftArrowIconHome';
import RatingStarIcon from '../../../../../../stories/Icons/RatingStarIcon';
import RightArrowIcon from '../../../../../../stories/Icons/RIghtArrowIconHome';
import fallbackImage from '../../../../../assets/fallback-image.png';
import GoStaysIcon from '../../../../../Icons/GoStaysIcon';
import ReviewAndRatings from '../../../SRP/ReviewAndRatings/ReviewAndRatings';
import * as S from './SegmentSliderUI.styles';
import GoSafeDetailedPersuasion from '../../../../../../stories/components/hotels/SRP/GoSafeDetailedPersuasion/GoSafeDetailedPersuasion';

import HappyNextIcon from '@stencil/icons/src/HappyNextIcon/HappyNextIcon';
import HappyPreviousIcon from '@stencil/icons/src/HappyPreviousIcon/HappyPreviousIcon';
import HappyRatingStarIcon from '@stencil/icons/src/HappyRatingStarIcon/HappyRatingStarIcon';

const SegmentSliderUI = ({
  data,
  actionHandler,
  eventMiddlewareForFE,
  sliderClicksGAHandler,
  goSafePersuasionTemplateId,
}: {
  data: ISegmentSliderData;
  actionHandler: Function;
  eventMiddlewareForFE;
  sliderClicksGAHandler;
  goSafePersuasionTemplateId: number;
}) => {
  const {data_list = [], city_meta_info = {}} = data;
  const {co = ''} = city_meta_info;
  const goStayIndex =
    city_meta_info && city_meta_info.ata ? city_meta_info.ata.indexOf('Gostays') : -1;
  return (
    <>
      {data_list.map((item, index) => (
        <S.SliderOuterWrapper key={'SegmentSliderItem' + Math.random() * 2938 + index}>
          <SegmentSliderItem
            item={item}
            country={co}
            actionHandler={actionHandler}
            eventMiddlewareForFE={eventMiddlewareForFE}
            sliderClicksGAHandler={sliderClicksGAHandler}
            goSafePersuasionTemplateId={goSafePersuasionTemplateId}
            goStayIndex={goStayIndex}
          />
        </S.SliderOuterWrapper>
      ))}
    </>
  );
};

export default React.memo(SegmentSliderUI);

const SegmentSliderItem = ({
  item,
  country,
  actionHandler,
  eventMiddlewareForFE,
  sliderClicksGAHandler,
  goSafePersuasionTemplateId,
  goStayIndex,
}) => {
  const {
    dataList,
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(item?.data, 3);

  return (
    <>
      <S.SliderHeaderWrapper>
        <div>
          <SectionHeader>{item.banner_data.t}</SectionHeader>
          <S.SliderHeaderSubText>
            {item.banner_data.mbg &&
              item.banner_data.mbg.length > 0 &&
              item.banner_data.mbg.map((mbgItem, index) => {
                if (index < item.banner_data.mbg.length - 1) return mbgItem + ' | ';
                return mbgItem;
              })}
          </S.SliderHeaderSubText>
        </div>
        {/* <S.SliderHeaderArrowWrapper> */}
        <S.SliderHeaderArrowWrapInner>
          <S.SliderArrowWrap
            onClick={eventMiddlewareForFE({
              onClick: () => {
                decrement();
                // sliderClicksGAHandler(`-${leftCursor}`);
              },
            })}
          >
            <HappyPreviousIcon
              fill={
                isLeftCursorActive
                  ? defaultTheme.colors.goBrandBlue.base
                  : defaultTheme.colors.goBrandBlue.medium
              }
            />
          </S.SliderArrowWrap>
          <S.SliderArrowWrap
            onClick={eventMiddlewareForFE({
              onClick: () => {
                increment();
                sliderClicksGAHandler(`${rightCursor}`);
              },
            })}
          >
            <HappyNextIcon
              fill={
                isRightCursorActive
                  ? defaultTheme.colors.goBrandBlue.base
                  : defaultTheme.colors.goBrandBlue.medium
              }
            />
          </S.SliderArrowWrap>
        </S.SliderHeaderArrowWrapInner>
        {/* </S.SliderHeaderArrowWrapper> */}
      </S.SliderHeaderWrapper>
      <S.SliderMainContentWrapper>
        {/* <SegmentTypeInfo /> */}
        {/* <SegmentTypeInfoGoStays /> */}
        {(item && item.banner_data && item.banner_data.img && (
          <S.SliderTypeOuterWrapper>
            <S.SliderLeftImgWrap
              src={item.banner_data.img || ''}
              alt={item.banner_data.img || ''}
              fallback={fallbackImage}
            />
          </S.SliderTypeOuterWrapper>
        )) ||
          null}
        <S.SliderHotelsOuterWrapper>
          <S.SliderHotelInnerWrapper>
            <S.SliderRelatedHotelsList>
              {dataList &&
                dataList.map((subItem, subItemIndex) => (
                  <li key={'SegmentSliderHotelItem' + Math.random() * 2938 + subItemIndex}>
                    <S.SliderListHoterOuterWrp
                      itemScope
                      itemType="http://schema.org/Hotel"
                      onClick={() => {
                        actionHandler(subItem, country);
                      }}
                    >
                      <S.SliderListHotelImageWrap>
                        <S.SliderListHotelImg itemProp="image" src={subItem.t} alt={subItem.t} />
                        {goStayIndex > -1 && subItem?.tgi?.includes(goStayIndex) && (
                          <>
                            <S.SliderGoStayOverlay>
                              <GoStaysIcon
                                height="3.2rem"
                                width="3.2rem"
                                fill={defaultTheme.colors.goBrandOrange.base}
                              />
                            </S.SliderGoStayOverlay>

                            <S.SliderQuarterCircle></S.SliderQuarterCircle>
                          </>
                        )}
                      </S.SliderListHotelImageWrap>
                      <S.SliderHotelInfoWrapper>
                        <S.SliderHotelInfoInnerWrapper>
                          <S.SliderHotelNameInfoWrap>
                            <S.StarRatingWrapperSpan
                              itemProp={subItem.hr ? 'starRating' : undefined}
                              content={subItem.hr && Array(subItem.hr).length}
                            >
                              {(subItem.hr && (
                                <>
                                  {[...Array(subItem.hr)].map((item, index) => (
                                    <HappyRatingStarIcon key={'starIcon' + index} />
                                  ))}
                                </>
                              )) ||
                                null}
                              {/* {(subItem?.npp && subItem?.npp.length && (
                              <S.GoSafeLogoImg src={subItem?.npp[0]?.iu} />
                            )) ||
                              null} */}
                            </S.StarRatingWrapperSpan>
                            <S.SliderHotelNameText itemProp="name">
                              {subItem.hn}
                            </S.SliderHotelNameText>

                            {/* <S.SliderHotelNameText itemProp="name">
                              {subItem.hn}
                            </S.SliderHotelNameText> */}
                            <S.SliderHotelLocationText itemProp="address">
                              {subItem.l}
                            </S.SliderHotelLocationText>
                            <ReviewAndRatings
                              hotelReview={subItem?.gr}
                              reviewCount={subItem?.rec}
                              ratingCount={subItem?.gr}
                              ratingType={subItem?.gri}
                              isHotelCard={false}
                            />
                          </S.SliderHotelNameInfoWrap>

                          <S.SliderHotelPriceInfoWrap>
                            {(subItem.opr && (
                              <S.PriceOuterWrap>
                                <S.OriginalPriceStrike>
                                  <S.RuppeStrike />
                                  {subItem.opr}
                                </S.OriginalPriceStrike>
                                <SectionHeader itemProp="priceRange">
                                  <S.RuppeAskingPrice />
                                  {subItem.spr}
                                </SectionHeader>
                                {/* <ExtraTaxesText>
                          +<RuppeExtraTax />
                          124 TAX
                        </ExtraTaxesText> */}
                                <S.PerNightText>per room / per night</S.PerNightText>
                              </S.PriceOuterWrap>
                            )) ||
                              null}
                            {/* <OfferTag /> */}
                          </S.SliderHotelPriceInfoWrap>
                        </S.SliderHotelInfoInnerWrapper>
                        {subItem?.cp2 &&
                          subItem?.cp2?.length &&
                          subItem?.cp2[0]?.tp === goSafePersuasionTemplateId && (
                            <GoSafeDetailedPersuasion
                              mainImage={subItem?.cp2[0]?.iu || ''}
                              message={subItem?.cp2[0]?.pt || ''}
                              style={{width: '100%', marginTop: '0.5rem'}}
                            />
                          )}
                      </S.SliderHotelInfoWrapper>
                      {/* {subItem?.cp2 &&
                        subItem?.cp2?.length &&
                        subItem?.cp2[0]?.tp === goSafePersuasionTemplateId && (
                          <GoSafeDetailedPersuasion
                            mainImage={subItem?.cp2[0]?.iu || ''}
                            message={subItem?.cp2[0]?.pt || ''}
                            style={{width: '100%', marginTop: '0.5rem'}}
                          />
                        )} */}
                    </S.SliderListHoterOuterWrp>
                  </li>
                ))}
            </S.SliderRelatedHotelsList>
          </S.SliderHotelInnerWrapper>
        </S.SliderHotelsOuterWrapper>
      </S.SliderMainContentWrapper>
    </>
  );
};
